import main from 'Theme/main'
import alternative from 'Theme/alternative'

export default {
  main,
  alternative,
}
